module.exports = __webpack_public_path__ + "img/ee.bd34935d.svg";